<script lang="ts" setup>
import CountryView from '@/components/country/view.vue'
import WorldView from '@/components/world/view.vue'

/**
 * Fetch all the necessary data. Fetch the meta and countries first,
 * to let the system know which are the available countries and which
 * are "meta" dimensions. Then fetch the tiles and the framework.
 */
const loading = ref('')

async function fetchData() {
    try {
        loading.value = 'Loading metadata and countries...'
        await Promise.all([useMeta().fetch(), useCountries().fetch()])
        loading.value = 'Loading framework...'
        await useFramework().fetch()
    } finally {
        loading.value = ''
    }
}
/**
 * Translations.
 */
const { t } = useI18n()

/**
 * Use the current parameters.
 */
const { config } = useParams()

/**
 * Get the name of a country.
 */
const { getName } = useCountries()

/**
 * Current country name.
 */
const countryName = computed(() => {
    return config.country ? getName(config.country) : t('world')
})

/**
 * Change the page title depending on selection.
 */
useTitle(countryName, {
    titleTemplate(title) {
        return title ? `${title} | ${t('title')}` : t('title')
    }
})

fetchData()
</script>
    
<template>
    <TransitionWrapper>
        <div
            v-if="config.mode === 'DATA'"
            class="relative inset-0 z-[999] h-full"
            :class="[
                config.country
                    ? 'flex grid-cols-[minmax(min(32.5em,50%),1fr)_minmax(0,4fr)] flex-col overflow-hidden text-[18px] min-[1300px]:grid'
                    : 'absolute'
            ]"
        >
            <UiLoader v-if="loading" class="bg-white">
                <p>{{ loading }}</p>
            </UiLoader>
            <component
                :is="config.country ? CountryView : WorldView"
                v-else
                class="pointer-events-auto col-start-2"
            >
                <ButtonClose />
            </component>
        </div>
    </TransitionWrapper>
</template>